import React from 'react'

const Pricing = () => {
  return (
    <div style={{marginTop:"80px"}}>Pricing</div>
  )
}

export default Pricing